export default __webpack_public_path__ + "static/media/stdG.b5cf5b29.svg";